module.exports = __webpack_public_path__ + "assets/img/cominca@2x.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/top/cominca@2x.png
// module id = F1mN
// module chunks = 1